@let savingDrawer = savingDrawer$ | async;
<nz-drawer
  [nzVisible]="(trainingQualificationCreateDrawerVisible$ | async) === true"
  [nzMask]="true"
  [nzMaskClosable]="true"
  [nzPlacement]="'right'"
  [nzClosable]="false"
  [nzTitle]="'general.add' | translate"
  [nzSize]="'large'"
  [nzFooter]="drawerFooter"
  (nzOnClose)="onDrawerClose()"
>
  <ng-container *nzDrawerContent>
    <form nz-form nzLayout="vertical">
      <wilson-training-qualifications-general-section
        [nameFormControl]="nameFormControl"
        [labelsFormControl]="labelsFormControl"
      ></wilson-training-qualifications-general-section>
      <hr />
      <nz-collapse nzGhost>
        <nz-collapse-panel
          nzCollapsible="icon"
          [nzHeader]="'general.staff' | translate"
          [nzActive]="true"
        >
          <div nz-row [nzGutter]="16" nzAlign="bottom">
            <div nz-col nzSpan="24" class="wilson-users-select-col">
              <wilson-qualifications-v2-multi-users-select
                [label]="'general.search' | translate"
                [formControl]="userIdsFormControl"
                [hideSelected]="false"
                [listOfSelected]="userIdList"
                (selectedIdsChange)="handleUserSelection($event)"
              ></wilson-qualifications-v2-multi-users-select>
            </div>
          </div>
        </nz-collapse-panel>
      </nz-collapse>
      <hr />
      <wilson-training-qualifications-table
        [trainingQualifications]="trainingQualifications"
        [providers]="(qualificationTrainingProviders$ | async) || []"
        [trainingQualificationRows]="trainingQualificationRows"
        [qualificationsFormControl]="qualificationsFormControl"
        (hasInvalidRows)="hasInvalidRows = $event"
        (validationState)="handleValidationState($event)"
        (refreshProviders)="refreshProviders()"
      ></wilson-training-qualifications-table>
      <hr />
      <wilson-training-qualifications-notes-section
        [notesFormControl]="notesFormControl"
      ></wilson-training-qualifications-notes-section>
    </form>
  </ng-container>
</nz-drawer>

<ng-template #drawerFooter>
  <wilson-training-qualifications-footer-section
    (cancelDrawer)="cancelDrawer()"
    [numEmployees]="userIdsFormControl.value?.length ?? 0"
    [validRows]="validRows"
    [numberOfTrainings]="numberOfTrainings"
    [loading]="savingDrawer"
    [saveButtonDisabled]="
      !userIdList.length ||
      !trainingQualificationRows.value?.length ||
      !nameFormControl.value?.length ||
      hasInvalidRows
    "
    (saveDrawer)="saveDrawer()"
  >
  </wilson-training-qualifications-footer-section>
</ng-template>
